<template>
  <div class="filter-layout flex">
    <div class="filter-layout-left flex-space flex-center">
      <slot name="filter-left"></slot>
    </div>
    <div class="fr-links">
      <slot name="filter-right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterLayout',
}
</script>

<style lang="scss"></style>
